'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXSpotlight = exports.Spotlight = undefined;

var _gt = require('ramda/src/gt');

var _gt2 = _interopRequireDefault(_gt);

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@blueprintjs/core');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _utils = require('../../utils');

var _vxSpotlightFields = require('./vx-spotlight-fields');

var _withSpotlight = require('./with-spotlight');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledInputGroup = (0, _glamorous2.default)(_core.InputGroup, { filterProps: ['isRtl'] })({}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr',
    '& .pt-input': {
      paddingRight: '30px !important'
    },
    '& .pt-input-action:last-child': {
      left: isRtl ? '0' : null,
      right: isRtl ? 'inherit' : null
    },
    '> .pt-icon:first-child': {
      left: isRtl ? 'inherit' : null,
      right: isRtl ? '0' : null
    }
  };
});

var ClearAllButton = function ClearAllButton(_ref2) {
  var onClickHandler = _ref2.onClickHandler;
  return _react2.default.createElement(_core.Button, {
    className: (0, _classnames2.default)(_core.Classes.MINIMAL),
    iconName: 'cross',
    onClick: onClickHandler
  });
};

ClearAllButton.propTypes = {
  onClickHandler: _propTypes2.default.func.isRequired
};

var Spotlight = exports.Spotlight = function Spotlight(_ref3) {
  var spotlight = _ref3.spotlight,
      onChangeTerm = _ref3.onChangeTerm,
      onChangeField = _ref3.onChangeField,
      FieldLabelRenderer = _ref3.FieldLabelRenderer,
      placeholder = _ref3.placeholder,
      hasClearAll = _ref3.hasClearAll,
      isRtl = _ref3.isRtl;

  var clearAllButton = hasClearAll && !(0, _isEmpty2.default)(spotlight.term) ? _react2.default.createElement(ClearAllButton, { onClickHandler: onChangeTerm }) : null;

  var rightElement = clearAllButton;
  if ((0, _gt2.default)((0, _utils.size)(spotlight.fields), 1)) {
    rightElement = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_vxSpotlightFields.VXSpotlightFields, {
        fields: spotlight.fields,
        onChangeField: onChangeField,
        FieldLabelRenderer: FieldLabelRenderer,
        isRtl: isRtl
      }),
      clearAllButton
    );
  }

  return _react2.default.createElement(StyledInputGroup, {
    leftIconName: 'search',
    onChange: onChangeTerm,
    placeholder: placeholder,
    value: spotlight.term,
    rightElement: rightElement,
    isRtl: isRtl
  });
};

Spotlight.propTypes = {
  /*spotlight: PropTypes.objectOf(PropTypes.shape({
    term: PropTypes.string,
    fields: PropTypes.object,
  })),*/
  onChangeTerm: _propTypes2.default.func.isRequired,
  onChangeField: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  FieldLabelRenderer: _propTypes2.default.func,
  hasClearAll: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool
};

var VXSpotlight = exports.VXSpotlight = (0, _withSpotlight.withSpotlight)(Spotlight);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-spotlight/index.js
// module id = 2038
// module chunks = 0